export const LOGIN_ENDPOINT = '/web/user/login'
export const VALIDATE_MEFRCHANT_KEY_ENDPOINT = 'zero/merchants/validate-api-key'
